import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class BemVindoRouterService
{
    constructor(private router: Router) {}
}
